import React from "react";
import { Text, TouchableOpacity } from "react-native";

import { styles } from "./styles";

export const Button = ({
  text,
  onPress,
  disabled,
  outline,
  color = "gray",
  background = "white",
}) => {
  const buttonStyle = [styles.button, { backgroundColor: background }];
  const textStyle = [styles.text, { color }];
  if (outline) {
    buttonStyle.push(styles.outline);
  }
  if (disabled) {
    textStyle.push(styles.disabled);
  }
  if (styles._text?.fontFamily === "Arial") {
    textStyle.push({ fontWeight: "bold" });
  }
  return (
    <TouchableOpacity onPress={onPress} disabled={disabled} style={buttonStyle}>
      <Text style={textStyle}>{text}</Text>
    </TouchableOpacity>
  );
};
